define('plugin/product/view/ProductListView',['require','lib/view/PaginatedCompositeView','plugin/product/view/ProductItemView','lib/view/UnwrapBehavior'],function (require) {

    var PaginatedCompositeView = require('lib/view/PaginatedCompositeView');
    var ProductItemView = require('plugin/product/view/ProductItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    /**
     * Products composite view (products container)
     *
     * @class ProductListView
     */
    return PaginatedCompositeView.extend({

        template: '#product_list_view',
        childView: ProductItemView,
        childViewContainer: '#sb_product_list_container',
        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        onDomRefresh: function () {
            // @todo let's think how to remove this
            var errors = this.getOption('bookingModel').validationError || {};
            if (errors.global_form) {
                Backbone.Wreqr.radio.vent.trigger('status_message', 'shown');
            } else if (errors && !_.isEmpty(errors)) {
                Backbone.Wreqr.radio.vent.trigger('field_error', 'shown', {
                    'type': 'client_details'
                });
            }
        }

    });

});
